import {
  ChangeDetectorRef,
  Component,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  convertUTCStringToOffset,
  getFormattedDateTime,
  getInitalDateRangeForListData,
  isLargeScreen,
} from '../../../../global.variable';
import { ClientSiteContactsComponent } from '../../../shared/components/client-site-contacts/client-site-contacts.component';
import { ConfirmDialogComponent } from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import { ContactComponent } from '../../../shared/components/contact/contact.component';
import { EventSchedulerComponent } from '../../../shared/components/event-scheduler/event-scheduler.component';
import { MediaPreviewComponent } from '../../../shared/components/media-preview/media-preview.component';
import { ModalDialogueService } from '../../../shared/components/modal-dialogue/modal-dialogue.service';
import { LoadingSpinnerService } from '../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../shared/services/toaster.service';
import { CheckpointService } from '../checkpoints/checkpoint.service';
import { ClientsService } from '../clients/clients.service';
import { getDateTimeRange } from '../tableDetails';
import { UserPromptService } from '../user-prompts/user-prompt.service';
import { UsersService } from '../users/users.service';
import { ModifyLetterheadLogoComponent } from '../../../shared/components/modify-letterhead-logo/modify-letterhead-logo.component';
import { PagesService } from '../pages.service';
import { JobsService } from '../jobs/jobs.service';

@Component({
  selector: 'gtapp-reports',
  templateUrl: './reports.component.html',
  styleUrl: './reports.component.scss',
  standalone: false,
})
export class ReportsComponent implements OnInit {
  uiTabs = {
    tab1: 'Jobs',
    tab2: 'Patrols',
    tab3: 'Discrepancies',
    tab4: 'Mobile Forms',
    tab5: 'Scheduled Reports', // called in view-site component
    tab6: 'Analytics',
    tab7: 'Time & Attendance',
    tab8: 'Configured Reports (legacy)',
  };
  largeView: Boolean = isLargeScreen;

  userEventDetailsTableView: any = [];
  userEventDetailsMobileView: any = {};

  tableStyle = {
    'overflow': 'auto',
    'max-height': '100%',
  };

  dateRange: any = {
    start: new Date(new Date().setDate(new Date().getDate() - 1)),
    end: new Date(new Date().setDate(new Date().getDate() + 1)),
  };
  sortKeys: any = [];
  searchParams: any;

  totalRows: number = 0;
  previous: number = 0;
  pageSize: number = 15;
  pageNum: number = 1;
  totalPages: number = 0;

  otherParams: any = {
    apiFiltering: true,
    tableRowStyle: (rowData: any) => {
      if (rowData?.is_deleted) {
        return {
          opacity: '0.4',
        };
      }
      return {};
    },
  };

  scrollPosition: any;

  allowPDFExport: boolean = false;
  userEvents: any;
  clientDropDownList: any = [];
  selectedEvent: any;

  userPrompts: any = [];
  selectedPromptIds: any = [];

  activeTab: string = '';

  reportContactDataDetail = [
    {
      header: 'Report',
      sortKey: 'report_name',
      searchKey: 'report_name',
      tableColumnStyle: {
        'white-space': 'pre-line',
      },
      nestedValue: (row: any) => {
        return row?.report_name ? `${row?.report_name}` : 'Completed Jobs';
      },
      suffixNestedValue: (row: any) => {
        return row?.report_name ? `\n[Patrols]` : '';
      },
      suffixStyle: {
        'font-size': '0.8rem',
      },
    },
    {
      header: 'Site',
      name: 'site_name',
      sortKey: 'site_name',
      searchKey: 'site_name',
      nestedValue: (row: any) => {
        return row?.site_name ? row.site_name : row?.company_name;
      },
      suffixNestedValue: (row: any) => {
        return row?.site_name ? `\n${row?.company_name}` : null;
      },
      suffixStyle: {
        'font-size': 'small',
      },
      tableColumnStyle: {
        'white-space': 'pre-line',
      },
    },
    { header: '', name: '', showAction: true },
  ];
  reportContactDataList: any = [];
  reportContactDataListTemp: any = [];
  reportContactDataDetailActionColumn = [
    {
      condition: function (row: any) {
        return {
          icon: 'fa-solid fa-link',
          title: 'Go to Report',
          type: 'redirect',
        };
      },
    },
  ];
  filterValue = { contact: '', site: '' };

  showSummaryOnly: boolean = false;
  showCheckpointScanLocation: boolean = false;

  reportSiteClientLookup: any = {
    client: {
      name: 'Client',
      value: '',

      data: null,
    },
    site: { name: 'Site', value: '', data: null },
  };
  siteListData: any = [];
  autoLookupDataBackupDict = { client: [], site: [] };

  fullReportRecipientList: any = [];

  modifyReportRecipients: boolean = false;
  reportModifySiteClient: any = {};

  previewReportData: any = {};
  today = new Date();
  previewReportDataAdditionalInfo: any = { hide_guard_column: true };

  previewPatrolReport: boolean = false;
  qrNfcScanExists: boolean = false;
  checkpointScanExists: boolean = false;

  newComment: any;
  previousComment: any;
  previewReportSummaryData: any = [];

  timeFilterRange: any;

  preLoadedData: any = {};

  selectedReportRecipientsListData: any = [];
  reportRecipientListData: any = [];
  promptFileIdDataDict: any = {};

  promptFileDataUrls: any = [];

  constructor(
    private userService: UsersService,
    private spinnerService: LoadingSpinnerService,
    private clientService: ClientsService,
    private dialogService: ModalDialogueService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private viewContainerRef: ViewContainerRef,
    private toasterService: ToasterService,
    private jobService: JobsService,
    private checkpointService: CheckpointService,
    private route: ActivatedRoute,
    private pageService: PagesService,
  ) {
    this.dateRange = getInitalDateRangeForListData(
      this.userEventDetailsMobileView?.individualDetails || [],
    );
  }

  ngOnInit(): void {
    this.getHomeScreenPrompts();
    [this.userEventDetailsTableView, this.userEventDetailsMobileView] =
      this.getPatrolTableDetails();

    const savedTab = sessionStorage.getItem('selectedTab');

    if (savedTab) {
      this.changeTab(savedTab);
    } else {
      this.activeTab = this.uiTabs.tab1;
    }
  }

  resetVariables() {
    this.previewPatrolReport = false;
    this.reportSiteClientLookup = {
      client: {
        name: 'Client',
        value: '',
        data: null,
      },
      site: {
        name: 'Site',
        value: '',
        data: null,
      },
    };
    this.tableStyle = {
      'overflow': 'auto',
      'max-height': '100%',
    };

    this.showSummaryOnly = false;
    this.showCheckpointScanLocation = false;
    this.clearPagination();
    this.selectedReportRecipientsListData = [];
    this.selectedPromptIds = [];
    this.selectedEvent = null;
    this.sortKeys = [];
    this.searchParams = null;

    this.userEvents = [];
    this.otherParams.paginationData = {};
    this.dateRange = null;
    [this.userEventDetailsTableView, this.userEventDetailsMobileView] =
      this.getPatrolTableDetails();

    this.dateRange = getInitalDateRangeForListData(
      this.userEventDetailsMobileView?.individualDetails || [],
    );
  }
  selectDropDown(event: any) {
    this.changeTab(event?.target?.value);
  }
  changeTab(event: any) {
    this.activeTab = event;

    // come back to the last selected tab if redirectd back/reloaded
    sessionStorage.setItem('selectedTab', this.activeTab);
    this.resetVariables();
    switch (this.activeTab) {
      case this.uiTabs.tab1:
        break;
      case this.uiTabs.tab2:
        this.sortKeys = ['updated_datetime'];
        [this.userEventDetailsTableView, this.userEventDetailsMobileView] =
          this.getPatrolTableDetails();

        break;
      case this.uiTabs.tab3:
        this.preLoadSiteAndClientDropdown();
        this.sortKeys = ['updated_datetime'];
        [this.userEventDetailsTableView, this.userEventDetailsMobileView] =
          this.getPatrolTableDetails();

        this.getEventLogData();
        break;
      case this.uiTabs.tab4:
        this.preLoadSiteAndClientDropdown();
        this.sortKeys = ['updated_datetime'];
        this.userEventDetailsTableView = [
          {
            header: 'Date',
            name: 'updated_datetime',
            datetimeObj: true,
            dateRangeKey: 'updated_datetime',
            sortKey: 'updated_datetime',
            ...getDateTimeRange(),
          },
          {
            header: 'Mobile Form',
            nestedValue: (row: any) => {
              const promptNames = row?.prompts?.map(
                (prompt: any) => prompt?.prompt_data?.name,
              );
              return promptNames?.join(',');
            },
          },

          {
            header: 'Site',
            name: 'site_name',
            searchKey: 'site_name',
          },
          {
            header: 'Guard',
            name: 'user_name',
            sortKey: 'user_name',
            searchKey: 'user_name',
          },
        ];
        this.userEventDetailsMobileView = {
          individualDetails: [
            {
              name: 'updated_datetime',
              datetimeObj: true,
              dateRangeKey: 'updated_datetime',
              header: 'Event Time',
              ...getDateTimeRange(),
              sortKey: 'updated_datetime',
              cardRowStyle: {
                'font-size': 'small',
                'float': 'right',
              },
            },
            {
              name: 'user_name',
              cardRowStyle: {
                'font-size': 'small',
                'float': 'end',
              },
            },
            {
              header: 'Mobile Form',
              cardRowStyle: {
                'font-size': 'small',
                'font-weight': 'bold',
              },
              nestedValue: (row: any) => {
                const promptNames = row?.prompts?.map(
                  (prompt: any) => prompt?.prompt_data?.name,
                );
                return promptNames?.join(',');
              },
            },

            {
              header: 'Site',
              name: 'site_name',
            },
          ],
        };
        break;
      case this.uiTabs.tab5:
        this.modifyReportRecipients = false;
        this.reportModifySiteClient = {};
        break;

      case this.uiTabs.tab8:
        this.getReportContactList();
        break;
    }
  }
  getApiRequestBody() {
    let body: any = {
      time_offset: new Date().getTimezoneOffset(),
    };

    if (this.dateRange) {
      body.date_range = this.dateRange;
      this.timeFilterRange = this.dateRange;
    }
    if (this.sortKeys) body.sort_key = this.sortKeys;
    if (this.searchParams) {
      body.search_filters = this.searchParams;
      if (
        this.searchParams?.updated_at__range &&
        this.searchParams?.updated_at__range?.length === 2 &&
        Array.isArray(this.searchParams?.updated_at__range)
      ) {
        this.timeFilterRange = {
          start: this.searchParams?.updated_at__range[0],
          end: this.searchParams?.updated_at__range[1],
        };
      }
    }
    if (this.pageSize) body.rows = this.pageSize;
    if (this.previous) body.previous = this.previous;

    switch (this.activeTab) {
      case this.uiTabs.tab1:
        break;
      case this.uiTabs.tab2:
        if (
          !this.reportSiteClientLookup?.site?.data?.id &&
          !this.reportSiteClientLookup?.client?.data?.id
        ) {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: 'Select a Site/Client',
          });
          return;
        }
        body.event_type = 'patrol';
        if (this.reportSiteClientLookup?.site?.data?.id) {
          body.site_id = this.reportSiteClientLookup?.site?.data?.id;
        } else {
          body.company_id = this.reportSiteClientLookup?.client?.data?.id;
        }

        break;
      case this.uiTabs.tab3:
        if (this.reportSiteClientLookup?.site?.data?.id) {
          body.site_id = this.reportSiteClientLookup?.site?.data?.id;
        }
        if (this.reportSiteClientLookup?.client?.data?.id) {
          body.company_id = this.reportSiteClientLookup?.client?.data?.id;
        }
        body.event_type = 'exceptions';
        break;
      case this.uiTabs.tab4:
        if (!this.selectedPromptIds?.length) return;
        if (
          !this.reportSiteClientLookup?.site?.data?.id &&
          !this.reportSiteClientLookup?.client?.data?.id
        ) {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: 'Select a Site/Client',
          });
          return;
        }

        body.event_type = 'patrol';
        body.user_prompt_ids = this.selectedPromptIds;
        if (this.reportSiteClientLookup?.site?.data?.id) {
          body.site_id = this.reportSiteClientLookup?.site?.data?.id;
        } else {
          body.company_id = this.reportSiteClientLookup?.client?.data?.id;
        }

        break;
    }
    return body;
  }
  getEventLogData() {
    let body = this.getApiRequestBody();
    this.spinnerService.show();
    this.userService.getUserUpdateLog(body).subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.allowPDFExport = true;
        this.selectedEvent = null;
        this.spinnerService.hide();
        this.totalRows = response['total_size'];
        this.otherParams.paginationData = {
          totalRows: this.totalRows,
          previousRows: this.previous,
          rows: this.pageSize,
          pageNum: this.pageNum,
          totalPages: Math.ceil(this.totalRows / this.pageSize),
        };

        this.userEvents = response?.data;
        if (this.activeTab == this.uiTabs.tab2) {
          this.filterSummaryData();
          if ('qr_nfc_exists' in response) {
            this.qrNfcScanExists = response?.qr_nfc_exists;
          }
          if ('checkpoint_scan_exists' in response) {
            this.checkpointScanExists = response?.checkpoint_scan_exists;
          }
        }

        this.totalPages = Math.ceil(this.totalRows / this.pageSize);
        this.preLoadNextPageData();
      } else {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: response['message'],
        });
        this.spinnerService.hide();
      }
    });
  }
  preLoadNextPageData() {
    if (this.pageNum < this.totalPages) {
      let body = this.getApiRequestBody();
      body.previous = (body?.previous || 0) + this.pageSize;
      // implies there is one more page to load
      this.userService.getUserUpdateLog(body).subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.preLoadedData[this.pageNum + 1] = response?.data;
        }
      });
    }
  }

  shiftFocus(elementId: string) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      element?.focus();
    }, 200);
  }
  getHomeScreenPrompts() {
    this.jobService.getHomeUserPromptList().subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.userPrompts = response?.data;
      }
    });
  }
  getReportContactList() {
    this.spinnerService.show();

    let body: any = {
      event_type: 'report_contacts',
    };

    this.userService.getUserUpdateLog(body).subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.reportContactDataList = response['data'];
        this.reportContactDataListTemp = response['data'];
        this.spinnerService.hide();
      } else {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: response['message'],
        });
        this.spinnerService.hide();
      }
    });
  }

  getTimeDifference(rowData: any) {
    const { on_site_date, off_site_date } = rowData;

    // * onsite and offsite time exists; else return null
    // * onsite and offsite hour and minute match || onsite > offsite; return 0;
    // * onsite < offsite; return difference

    if (off_site_date && on_site_date) {
      let date1 = new Date(on_site_date);
      let date2 = new Date(off_site_date);

      if (
        date1 > date2 ||
        (date1.getHours() === date2.getHours() &&
          date1.getMinutes() === date2.getMinutes())
      ) {
        return 0;
      }

      const diffInMs = date2.getTime() - date1.getTime();
      const diffInHours = diffInMs / (1000 * 60 * 60);
      const hours = Math.floor(diffInHours);
      const minutes = Math.round((diffInHours - hours) * 60);

      // Pad the hours and minutes with leading zeros
      const hours_str = hours < 10 ? '0' + hours : hours;
      const minutes_str = minutes < 10 ? '0' + minutes : minutes;

      return `${hours_str}:${minutes_str}`;
    } else {
      return 0;
    }
  }

  onTableRowClick(event: any) {
    this.scrollPosition = window.scrollY;
    this.selectedEvent = event;
    this.tableStyle = {
      'overflow': 'auto',
      'max-height': '35vh',
    };
    if (this.largeView) window.scrollTo(0, document.body.scrollHeight);
  }
  onChangePreviewPagination(event: any) {
    this.previous = event.previous;
    this.pageNum = event.pageNum;

    if (event.pageSize === this.pageSize) {
      this.pageSize = event.pageSize;
      // do preloading only here
      if (this.preLoadedData?.[this.pageNum]) {
        this.otherParams.paginationData = {
          totalRows: this.totalRows,
          previousRows: this.previous,
          rows: this.pageSize,
          pageNum: this.pageNum,
          totalPages: Math.ceil(this.totalRows / this.pageSize),
        };

        this.userEvents = this.preLoadedData?.[this.pageNum];
        this.filterSummaryData();
        this.totalPages = Math.ceil(this.totalRows / this.pageSize);
        const nextPage = this.pageNum + 1;
        if (!this.preLoadedData?.[nextPage]) this.preLoadNextPageData();
      } else {
        this.getEventLogData();
      }
    } else {
      this.pageSize = event.pageSize;
      this.getEventLogData();
    }
  }

  onChangePagination(data: any) {
    this.previous = data?.paginationData?.previousRows;
    this.pageNum = data?.paginationData?.pageNum;

    if (data?.paginationData?.rows == this.pageSize) {
      this.pageSize = data?.paginationData?.rows;
      // do preloading only here
      if (this.preLoadedData?.[this.pageNum]) {
        this.otherParams.paginationData = {
          totalRows: this.totalRows,
          previousRows: this.previous,
          rows: this.pageSize,
          pageNum: this.pageNum,
          totalPages: Math.ceil(this.totalRows / this.pageSize),
        };

        this.userEvents = this.preLoadedData?.[this.pageNum];
        this.filterSummaryData();
        this.totalPages = Math.ceil(this.totalRows / this.pageSize);
        const nextPage = this.pageNum + 1;
        if (!this.preLoadedData?.[nextPage]) this.preLoadNextPageData();
      } else {
        this.getEventLogData();
        this.otherParams.paginationData = { ...data?.paginationData };
      }
    } else {
      this.preLoadedData = {};
      this.pageSize = data?.paginationData?.rows;
      this.getEventLogData();
      this.otherParams.paginationData = { ...data?.paginationData };
    }
  }

  sortColumn(body: any) {
    this.clearPagination();
    this.sortKeys = body?.sortList || [];

    this.searchParams = body?.searchParams || {};
    if (body?.site_id) {
      this.searchParams = { ...this.searchParams, site_id: body?.site_id };
    }

    this.getEventLogData();
  }
  clearPagination() {
    this.preLoadedData = {};
    this.totalRows = 0;
    this.previous = 0;
    this.pageSize = 10;
    this.pageNum = 1;
    this.totalPages = 0;
    this.otherParams.paginationData = {
      totalRows: 0,
      previousRows: this.previous,
      rows: this.pageSize,
      pageNum: this.pageNum,
      totalPages: this.totalPages,
    };
  }
  searchColumn(event: any) {
    this.clearPagination();
    this.dateRange = null;

    this.searchParams = event?.searchParams || {};

    if (event?.site_id) {
      this.searchParams = { ...this.searchParams, site_id: event?.site_id };
    }
    this.getEventLogData();
  }
  preLoadSiteAndClientDropdown() {
    if (!this.autoLookupDataBackupDict.client?.length) this.searchClients('');
    if (!this.autoLookupDataBackupDict.site?.length) this.onSiteSearch();
  }

  onClientSearch(event: any) {
    this.searchClients(event.target.value);
  }
  searchClients(searchStr?: any) {
    this.clientService.searchClients(searchStr).subscribe((res: any) => {
      if (res['status'] == 'success') {
        this.clientDropDownList = res?.data;
        if (!searchStr) {
          this.autoLookupDataBackupDict.client = JSON.parse(
            JSON.stringify(this.clientDropDownList),
          );
        }
      }
    });
  }
  onClientSelect(data: any) {
    this.resetVariables();
    this.reportSiteClientLookup = {
      client: {
        name: 'Client',
        value: data?.company_name,

        data: data,
      },
      site: { name: 'Site', value: '', data: null },
    };
    this.sortKeys = ['updated_datetime'];
    if (this.activeTab == this.uiTabs.tab2) {
      this.getSiteClientReportInfo();
    }
    if ([this.uiTabs.tab2, this.uiTabs.tab3].includes(this.activeTab)) {
      this.getEventLogData();
    }
  }
  onSiteSearch(event?: any) {
    const searchString = event ? event.target.value : '';

    this.clientService
      .searchSites({
        search_str: searchString,
      })
      .subscribe((res: any) => {
        if (res['status'] == 'success') {
          this.siteListData = res?.data?.splice(0, 10);
          if (!event) {
            this.autoLookupDataBackupDict.site = JSON.parse(
              JSON.stringify(this.siteListData),
            );
          }
        }
      });
  }
  onSelectSite(data: any) {
    this.resetVariables();
    this.reportSiteClientLookup = {
      client: {
        name: 'Client',
        value: '',
        data: null,
      },
      site: {
        name: 'Site',
        value: data?.company_name,
        data: data,
      },
    };
    this.sortKeys = ['updated_datetime'];

    if (this.activeTab == this.uiTabs.tab2) {
      this.getSiteClientReportInfo();
    }
    if ([this.uiTabs.tab2, this.uiTabs.tab3].includes(this.activeTab)) {
      this.getEventLogData();
    }
  }

  exportData(exportType: any) {
    let body: any = {
      export_type: exportType,
      user_ids: this.selectedReportRecipientsListData,
      time_offset: new Date().getTimezoneOffset(),
    };
    if (this.dateRange) body.date_range = this.dateRange;
    if (this.sortKeys) body.sort_key = this.sortKeys;
    if (this.searchParams) body.search_filters = this.searchParams;
    switch (this.activeTab) {
      case this.uiTabs.tab1:
        break;
      case this.uiTabs.tab2:
        if (
          !this.reportSiteClientLookup?.site?.data?.id &&
          !this.reportSiteClientLookup?.client?.data?.id
        ) {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: 'Select a Site/Client',
          });
          return;
        }
        if (!this.selectedReportRecipientsListData?.length) return;

        body.event_type = 'patrol';
        if (this.reportSiteClientLookup?.site?.data?.id) {
          body.site_id = this.reportSiteClientLookup?.site?.data?.id;
        } else {
          body.company_id = this.reportSiteClientLookup?.client?.data?.id;
        }
        body.summary_only = this.showSummaryOnly;
        body.show_checkpoint_scan_location = this.showCheckpointScanLocation;
        body.additional_info = this.previewReportDataAdditionalInfo;

        break;
      case this.uiTabs.tab3:
        if (this.reportSiteClientLookup?.site?.data?.id) {
          body.site_id = this.reportSiteClientLookup?.site?.data?.id;
        }
        if (this.reportSiteClientLookup?.client?.data?.id) {
          body.company_id = this.reportSiteClientLookup?.client?.data?.id;
        }
        body.event_type = 'exceptions';
        break;
      case this.uiTabs.tab4:
        if (!this.selectedPromptIds?.length) return;
        if (
          !this.reportSiteClientLookup?.site?.data?.id &&
          !this.reportSiteClientLookup?.client?.data?.id
        ) {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: 'Select a Site/Client',
          });
          return;
        }

        body.event_type = 'patrol';
        body.user_prompt_ids = this.selectedPromptIds;
        if (this.reportSiteClientLookup?.site?.data?.id) {
          body.site_id = this.reportSiteClientLookup?.site?.data?.id;
        } else {
          body.company_id = this.reportSiteClientLookup?.client?.data?.id;
        }

        break;
    }

    this.spinnerService.show();
    this.userService.exportUserUpdateLog(body).then((response: any) => {
      if (response['status'] == 'success') {
        this.toasterService.setMessage({
          successMessage: response['message'],
          errorMessage: '',
        });

        // this.restartEverything();
        this.spinnerService.hide();
      } else {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: response['message'],
        });
        this.spinnerService.hide();
      }
    });
  }
  restartEverything() {
    this.previewPatrolReport = false;
    this.allowPDFExport = false;
    this.userPrompts?.forEach((item: any) => {
      item.selected = false;
    });
    // this.activeTab = this.uiTabs.tab1;
    this.resetVariables();
    this.reportSiteClientLookup = {
      client: {
        name: 'Client',
        value: '',
        data: null,
      },
      site: {
        name: 'Site',
        value: '',
        data: null,
      },
    };
  }

  hideDetails() {
    this.selectedEvent = null;

    // let scrollPosition: any = window.localStorage.getItem('scrollToView');
    setTimeout(() => {
      window.scrollTo(0, this.scrollPosition);
    }, 100);
  }

  openTemplate(
    template?: any,
    source: 'mobileForms' | 'pdfRecipients' | 'xlRecipients' = 'pdfRecipients',
  ) {
    if (source === 'mobileForms') {
      this.userPrompts?.forEach((item: any) => {
        item.selected = false;
      });
    } else {
      this.getReportRecipients();
    }

    this.dialogService.open(
      template,
      { data: { source } },
      this.viewContainerRef,
    );
  }
  selectAllContacts(event: any) {
    const checked = event.target.checked;
    if (checked) {
      this.reportRecipientListData?.forEach(
        (contact: any) => (contact.isSnubbed = false),
      );
      this.selectedReportRecipientsListData = [
        ...new Set(
          this.reportRecipientListData
            ?.filter((recipient: any) => !recipient?.isSnubbed)
            ?.map((recipient: any) => recipient?.pk),
        ),
      ];
    } else {
      this.selectedReportRecipientsListData = [];
      this.reportRecipientListData?.forEach(
        (contact: any) => (contact.isSnubbed = true),
      );
    }
  }

  selectUnselectRecipients(contact: any) {
    contact.isSnubbed = !contact?.isSnubbed;

    this.selectedReportRecipientsListData = [
      ...new Set(
        this.reportRecipientListData
          ?.filter((recipient: any) => !recipient?.isSnubbed)
          ?.map((recipient: any) => recipient?.pk),
      ),
    ];
  }
  getReportRecipients() {
    let params: any = { get_manual_patrol_report_contacts: 1 };

    if (this.reportSiteClientLookup?.site?.data?.id) {
      params.site_id = this.reportSiteClientLookup?.site?.data?.id;
    }
    if (this.reportSiteClientLookup?.client?.data?.id) {
      params.company_id = this.reportSiteClientLookup?.client?.data?.id;
    }

    this.clientService
      .searchLocationContacts(params)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.reportRecipientListData = response?.data;

          this.selectedReportRecipientsListData = [
            ...new Set(
              this.reportRecipientListData
                ?.filter((recipient: any) => !recipient?.isSnubbed)
                ?.map((recipient: any) => recipient?.pk),
            ),
          ];
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }

  // addToContactsTemp() {
  //   let data: any = {};
  //   if (this.reportSiteClientLookup?.site?.data?.id) {
  //     data = {
  //       siteData: this.reportSiteClientLookup?.site?.data,
  //       patrolReportUsers: true,
  //       contactType: 'lc',
  //     };
  //   }
  //   if (this.reportSiteClientLookup?.client?.data?.id) {
  //     data = {
  //       clientData: this.reportSiteClientLookup?.client?.data,
  //       patrolReportUsers: true,
  //       contactType: 'lc',
  //     };
  //   }

  //   const dialogRef = this.dialogService.open(ContactComponent, {
  //     data: data,
  //   });
  //   dialogRef.afterClosed().subscribe((value: any) => {
  //     this.spinnerService.hide();
  //     if (value !== 'false' && value?.length) {
  //       let lastAddedContact = value[value?.length - 1];
  //       if (lastAddedContact)
  //         this.addUser(lastAddedContact?.id, lastAddedContact);
  //     }
  //   });
  // }

  selectUserPrompt(promtData: any) {
    promtData.selected = !promtData?.selected;
    this.selectedPromptIds = [
      ...new Set(
        this.userPrompts
          ?.filter((item: any) => item?.selected)
          ?.map((item: any) => item?.id),
      ),
    ];
  }

  onReportContactActionIconClick(event: any) {
    if (event?.type == 'redirect') {
      const fragment = event?.event?.report_uuid ? 'pc' : 'jc';
      if (event?.event?.site_uuid) {
        this.navigateToSiteClient('site', event?.event?.site_uuid, fragment);
      } else {
        this.navigateToSiteClient(
          'client',
          event?.event?.company_uuid,
          fragment,
        );
      }
    }
  }
  navigateToSiteClient(route: string, id: any, fragment: string = 'pc') {
    if (route === 'site') {
      this.router.navigate(['/view-site', { sKey: String(id) }], {
        fragment: fragment,
      });
    } else {
      this.router.navigate(['/view-client', { cKey: String(id) }], {
        fragment: fragment,
      });
    }
  }
  filterByContact(contact: any, searchStr: string) {
    return searchStr
      ? contact?.contact_data?.full_name?.toLowerCase()?.includes(searchStr) ||
          contact?.contact_data?.email?.toLowerCase()?.includes(searchStr)
      : contact;
  }
  expandCollapseContactTable(selectedContact: any) {
    selectedContact.contact_data.expanded =
      !selectedContact?.contact_data?.expanded;
    this.reportContactDataListTemp?.forEach((contact: any) => {
      if (contact?.contact_data?.email === selectedContact?.contact_data?.email)
        contact.contact_data.expanded = selectedContact.contact_data.expanded;
    });
  }

  filterReportContacts(filterBy: string = 'site') {
    this.reportContactDataList = JSON.parse(
      JSON.stringify(this.reportContactDataListTemp),
    );
    if (this.filterValue.site) {
      this.reportContactDataList?.forEach((contact: any) => {
        const existingReports = [...contact?.reports];

        contact.reports = existingReports?.filter(
          (report: any) =>
            report?.site_name
              ?.toLowerCase()
              ?.includes(this.filterValue.site?.toLowerCase()) ||
            report?.company_name
              ?.toLowerCase()
              ?.includes(this.filterValue.site?.toLowerCase()),
        );
      });
    }

    this.reportContactDataList = this.reportContactDataList?.filter(
      (contact: any) =>
        this.filterByContact(
          contact,
          this.filterValue.contact?.toLowerCase(),
        ) && contact?.reports?.length,
    );
  }
  editField(field: string) {
    this.selectedEvent = null;
    this.reportSiteClientLookup.site = {
      name: 'Site',
      value: '',
      data: null,
    };
    this.reportSiteClientLookup.client = {
      name: 'Client',
      value: '',
      data: null,
    };
    if (field == 'site') {
      this.shiftFocus('siteId');
    }
    if (field == 'client') {
      this.shiftFocus('clientLookupId');
    }

    this.updateInitialDataList(field);
  }
  inputFocused(field: string) {
    this.reportSiteClientLookup.client = {
      name: 'Client',
      value: '',
      data: null,
    };
    this.reportSiteClientLookup.site = {
      name: 'Site',
      value: '',
      data: null,
    };
    if (field === 'site') {
      this.reportSiteClientLookup.client = {
        name: 'Client',
        value: '',
        data: null,
        hide: true,
      };
      setTimeout(() => {
        this.reportSiteClientLookup.client = {
          name: 'Client',
          value: '',
          data: null,
          disabled: true,
        };
      }, 10);
    }
    if (field === 'client') {
      this.reportSiteClientLookup.site = {
        name: 'Site',
        value: '',
        data: null,
        hide: true,
      };
      setTimeout(() => {
        this.reportSiteClientLookup.site = {
          name: 'Site',
          value: '',
          data: null,
          disabled: true,
        };
      }, 10);
    }
    this.updateInitialDataList(field);
  }
  updateInitialDataList(field: any) {
    this.siteListData = [];
    this.clientDropDownList = [];

    setTimeout(() => {
      if (field === 'site') {
        this.siteListData = JSON.parse(
          JSON.stringify(this.autoLookupDataBackupDict?.['site'] || []),
        );
      } else if (field === 'client') {
        this.clientDropDownList = JSON.parse(
          JSON.stringify(this.autoLookupDataBackupDict?.['client'] || []),
        );
      }

      this.cdr.detectChanges();
    }, 200);
  }
  getPatrolTableDetails() {
    const patrolTableDetailMobileView = {
      individualDetails: [
        {
          name: 'updated_datetime',
          datetimeObj: true,
          dateRangeKey: 'updated_datetime',
          header: 'Event Time',
          ...getDateTimeRange(),
          sortKey: 'updated_datetime',
          cardRowStyle: {
            'font-size': 'small',
            'float': 'right',
          },
          sortOrder: 'asc',
        },
        {
          name: 'user_name',
          cardRowStyle: {
            'font-size': 'small',
            'float': 'end',
          },
        },
        {
          name: 'action',
          cardRowStyle: {
            'font-size': 'small',
            'font-weight': 'bold',
            'text-transform': 'uppercase',
          },
        },

        {
          name: 'detail',
          cardRowStyle: {
            'font-size': 'small',
          },
        },
        {
          header: 'Site',
          name: 'site_name',
        },
      ],
    };

    const patrolTableDetail = [
      {
        header: 'Date',
        name: 'updated_datetime',
        datetimeObj: true,
        dateRangeKey: 'updated_datetime',
        sortKey: 'updated_datetime',
        ...getDateTimeRange(),
        sortOrder: 'asc',
      },
      {
        header: 'Event Type',
        name: 'action',
      },

      {
        header: 'Checkpoint',
        columnDataStyle: {
          'white-space': 'pre-line',
        },
        nestedValue: (row: any) => {
          return [0, 6, 12].includes(row?.event_action) ? row?.detail : '';
        },
      },
      {
        header: 'Location',
        nestedValue: (row: any) => {
          return `${row?.gps?.lat?.toFixed(4)}, ${row?.gps?.lon?.toFixed(4)}`;
        },
      },
      {
        header: 'Site',
        name: 'site_name',
        searchKey: 'site_name',
      },
      {
        header: 'Guard',
        name: 'user_name',
        sortKey: 'user_name',
        searchKey: 'user_name',
      },
    ];
    return [patrolTableDetail, patrolTableDetailMobileView];
  }

  onSelectReportModifySiteClient(item: any, _type: string = 'site') {
    this.reportModifySiteClient = {};
    if (_type == 'site') {
      this.clientService
        .searchLocationContacts({
          site_id: item?.id,
          get_contacts: 1,
        })
        .subscribe((response: any) => {
          if (response['status'] == 'success') {
            this.reportModifySiteClient = response?.data;
            this.reportModifySiteClient['site'] = item;
          }
        });
    } else {
      this.clientService
        .searchLocationContacts({
          company_id: item?.id,
          get_contacts: 1,
        })
        .subscribe((response: any) => {
          if (response['status'] == 'success') {
            this.reportModifySiteClient = response?.data;
            this.reportModifySiteClient['client'] = item;
          }
        });
    }
  }
  openSchedulerTemplate(schedule?: any) {
    let data: any = { scheduleData: schedule };
    let itemData: any;
    let _type: string = '';
    if (this.reportModifySiteClient?.site?.id) {
      data['siteData'] = this.reportModifySiteClient?.site;
      itemData = this.reportModifySiteClient?.site;
      _type = 'site';
    } else {
      data['clientData'] = this.reportModifySiteClient?.client;
      itemData = this.reportModifySiteClient?.client;
      _type = 'client';
    }
    const dialogRef = this.dialogService.open(EventSchedulerComponent, {
      data: data,
    });
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value !== false) {
        this.onSelectReportModifySiteClient(itemData, _type);
      }
    });
  }
  openSiteClientContactTemplate(contactData: any) {
    let data: any = { contactType: 'jc', contactData: contactData };
    let itemData: any;
    let _type: string = '';
    if (this.reportModifySiteClient?.site?.id) {
      data['siteData'] = this.reportModifySiteClient?.site;
      itemData = this.reportModifySiteClient?.site;
      _type = 'site';
    } else {
      data['clientData'] = this.reportModifySiteClient?.client;
      itemData = this.reportModifySiteClient?.client;
      _type = 'client';
    }
    const dialogRef = this.dialogService.open(ContactComponent, {
      data: data,
    });
    dialogRef.afterClosed().subscribe((dialogResponse: any) => {
      if (dialogResponse !== false) {
        this.onSelectReportModifySiteClient(itemData, _type);
      }
    });
  }
  openJobReportContactTemplate() {
    let data: any = {
      contactType: 'jc',
      selectedUsers: this.reportModifySiteClient?.job_report_recipients,
    };
    let itemData: any;
    let _type: string = '';
    if (this.reportModifySiteClient?.site?.id) {
      data['siteData'] = this.reportModifySiteClient?.site;
      itemData = this.reportModifySiteClient?.site;
      _type = 'site';
    } else {
      data['clientData'] = this.reportModifySiteClient?.client;
      itemData = this.reportModifySiteClient?.client;
      _type = 'client';
    }

    const dialogRef = this.dialogService.open(ClientSiteContactsComponent, {
      data: data,
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      this.onSelectReportModifySiteClient(itemData, _type);
    });
  }
  deleteRestoreUserUpdate(event: any) {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: event?.type === 'delete' ? 'Delete Event' : 'Restore Event',
        message:
          event?.type === 'delete'
            ? `Are you sure you want to delete this event?`
            : 'Are you sure you want to restore this event?',
      },
    });
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value === true) {
        this.spinnerService.show();
        let body: any = {
          id: event?.event?.id,
        };
        body[event?.type === 'delete' ? 'delete_update' : 'restore_update'] = 1;
        this.updateUserUpdate(body);
      }
    });
  }
  updateUserUpdate(body: any) {
    this.spinnerService.show();
    this.checkpointService.updateClient(body).then((response: any) => {
      if (response?.status == 'success') {
        setTimeout(() => {
          this.spinnerService.hide();
          this.getEventLogData();
          this.toasterService.setMessage({
            successMessage: response?.message,
            errorMessage: '',
          });
        }, 100);
      } else {
        this.spinnerService.hide();
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: response?.message,
        });
      }
    });
  }
  deleteComment(data: any) {
    this.spinnerService.show();
    let body: any = {
      company_id: data?.company_id,
      comment: '',
      id: data?.id,
      edit_comment: 1,
    };
    this.updateUserUpdate(body);
  }
  openCommentTemplate(commentTemplate: TemplateRef<any>, commentData: any) {
    this.newComment = commentData?.detail;
    this.previousComment = commentData?.detail;
    this.dialogService.open(
      commentTemplate,
      {
        data: commentData,
      },
      this.viewContainerRef,
    );
  }
  editComment(data: any) {
    if (!data?.id && !this.newComment?.trim()) {
      this.toasterService.setMessage({
        successMessage: '',
        errorMessage: 'Comment cannot be empty',
      });
      return;
    }

    this.spinnerService.show();
    let body = {
      company_id: data?.company_id,
      comment: this.newComment,
      id: data?.id,
      edit_comment: 1,
    };
    this.updateUserUpdate(body);
  }
  editEventTimeStamp(rowData: any, template: any) {
    const currentValue = getFormattedDateTime(rowData?.updated_datetime);
    let maxDateTime = new Date();
    let minDateTime: any;
    const dialogRef = this.dialogService.open(
      template,
      {
        data: {
          name: rowData?.action,
          currentValue: currentValue,
          newValue: currentValue,
          minDateTime: minDateTime ? getFormattedDateTime(minDateTime) : null,
          maxDateTime: maxDateTime ? getFormattedDateTime(maxDateTime) : null,
        },
      },
      this.viewContainerRef,
    );
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value !== false) {
        let body: any = {
          event_id: rowData?.id,
          user_provided_timestamp: new Date(
            value?.newValue || value?.currentValue,
          ),
          change_event_timestamp: 1,
        };

        this.updateUserUpdate(body);
      }
    });
  }
  changeStatusTimeStamp(event: any, eventData: any) {
    const selectedTime = event?.target.value
      ? new Date(event?.target.value).getTime()
      : new Date(eventData?.currentValue).getTime();

    let valid = true;

    if (eventData?.minDateTime)
      valid = selectedTime >= new Date(eventData?.minDateTime)?.getTime();

    if (eventData?.maxDateTime)
      valid =
        valid && selectedTime <= new Date(eventData?.maxDateTime)?.getTime();

    eventData.valid = valid;
  }
  onOpenImage(event: any, data: any) {
    var target = event.target || event.srcElement || event.currentTarget;
    var srcAttr = target.attributes.src;

    this.dialogService.open(MediaPreviewComponent, {
      data: {
        mediaSrc: srcAttr.nodeValue,
        timeStamp: data?.updated_datetime || data?.updated_at,
      },
    });
  }
  scrollToSection(event: Event, sectionId: string) {
    event.preventDefault();
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
  }
  getSiteClientReportInfo() {
    this.spinnerService.show();
    let body: any = { event_type: 'preview_patrol_report' };
    if (this.reportSiteClientLookup?.site?.data?.id) {
      body.site_id = this.reportSiteClientLookup?.site?.data?.id;
    } else {
      body.company_id = this.reportSiteClientLookup?.client?.data?.id;
    }
    // body.additional_info = this.previewReportDataAdditionalInfo;
    this.userService.getUserUpdateLog(body).subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.spinnerService.hide();
        this.previewReportData = response?.data;
      } else {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: response['message'],
        });
        this.spinnerService.hide();
      }
    });
  }
  clearAndFocusTextBox(elementId: string) {
    this.newComment = '';
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      element?.focus();
    }, 100);
  }
  getFileIdsFromNestedData(innerItem: any, newPromptFileIdDataDict: any) {
    if (innerItem?.options && innerItem?.options?.length) {
      innerItem?.options?.forEach((item: any) => {
        if (item?.file_id) {
          newPromptFileIdDataDict[item?.file_id] = item?.description;
        }
        this.getFileIdsFromNestedData(item, newPromptFileIdDataDict);
      });
    }
  }
  getPromptFileIds() {
    const newPromptFileIdDataDict: any = {};
    this.previewReportSummaryData?.forEach((item: any) => {
      if (item?.prompts?.length) {
        item?.prompts?.forEach((outerItem: any) => {
          outerItem?.data?.forEach((innerItem: any) => {
            if (innerItem?.file_id) {
              newPromptFileIdDataDict[innerItem?.file_id] =
                innerItem?.description;
            }
            this.getFileIdsFromNestedData(innerItem, newPromptFileIdDataDict);
          });
        });
      }
    });

    this.promptFileIdDataDict =
      JSON.parse(JSON.stringify(newPromptFileIdDataDict)) || {};

    const promptFileIds = Object.keys(this.promptFileIdDataDict) || [];

    if (promptFileIds?.length) {
      this.getS3Urls(promptFileIds);
    }
  }
  getS3Urls(promptFileIds: any) {
    this.pageService
      .manageS3Urls({ file_ids: promptFileIds }, { get_file_urls: 1 })
      .subscribe((response: any) => {
        this.promptFileDataUrls = [];
        const responseData = response?.data || {};
        for (const file_id in responseData) {
          let resp: any = responseData?.[file_id] || {};
          resp['file_id'] = file_id;
          resp['description'] = this.promptFileIdDataDict?.[file_id] || '';
          this.promptFileDataUrls.push(resp);
        }

        this.cdr.detectChanges();
      });
  }
  filterSummaryData() {
    const events = JSON.parse(JSON.stringify(this.userEvents));

    if (this.previewReportDataAdditionalInfo?.hide_uploads) {
      this.previewReportSummaryData = events?.filter(
        (update: any) => !update?.file,
      );
    } else {
      this.previewReportSummaryData = events;
    }
    this.getPromptFileIds();
  }

  modifyLetterHeadLogo() {
    const dialogRef = this.dialogService.open(ModifyLetterheadLogoComponent, {
      data: {
        logoUsed:
          this.previewReportData?.patrol_detail?.subscriber_info?.logo_used,
        siteData: {
          id: this.reportSiteClientLookup?.site?.data?.id,
          company_name: this.reportSiteClientLookup?.site?.data?.company_name,
        },
        clientData: {
          id:
            this.reportSiteClientLookup?.site?.data?.company?.id ||
            this.reportSiteClientLookup?.client?.data?.id,
          company_name:
            this.reportSiteClientLookup?.site?.data?.company?.company_name ||
            this.reportSiteClientLookup?.client?.data?.company_name,
          is_subcontracting:
            this.previewReportData?.patrol_detail?.is_subcontracting,
        },
      },
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        this.getSiteClientReportInfo();
      }
    });
  }
}
